import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable, signal } from '@angular/core';
import { of } from 'rxjs/internal/observable/of';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { Port } from 'src/types';
import { SKIP_ERROR_LOGGING } from '../interceptors/http-error.interceptor';

@Injectable({ providedIn: 'root' })
export class PortsService {
  private _localPorts = signal<Port[]>([]);
  localPorts = this._localPorts.asReadonly();

  setLocalPorts(data: Port[]) {
    this._localPorts.set(data);
  }

  constructor(private http: HttpClient) {}

  searchPorts(term = '') {
    const query = term.trim();
    if (!query) return of<Port[]>([]);

    return this.http.get<Port[]>(
      `${environment.siglarApi.url}/api/v1/autocomplete/port?visibility=webform&query=${encodeURIComponent(query)}`
    );
  }
  filterPorts(value: string | Port) {
    if (value && typeof value === 'string') {
      return this.searchPorts(value).pipe(
        map((port) => port),
        catchError(() => {
          const ports = this.localPorts()
            .filter(
              (item: Port) =>
                String(item.name).toLowerCase().includes(value.toLowerCase()) ||
                String(item.unlocode).toLowerCase().includes(value.toLowerCase())
            )
            .slice(0, 12);
          return of(ports);
        })
      );
    } else {
      return of([]);
    }
  }

  getAllPorts() {
    return this.http.get<string[][]>(`/assets/ports.json`, {
      context: new HttpContext().set(SKIP_ERROR_LOGGING, true),
    }).pipe(catchError(() => of([])));
  }
}
